import { cn } from "@/lib/utils";

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Integer cents to dollars, always two decimals, columns line up. Never coloured: money is not
 * good or bad, and red/green would imply a judgement the amount does not carry. */
export function formatMoney(cents: number): string {
  return usd.format(cents / 100);
}

export function Money({
  cents,
  strong,
  className,
}: {
  cents: number;
  strong?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("tabular whitespace-nowrap", strong && "font-semibold", className)}>
      {formatMoney(cents)}
    </span>
  );
}
